export default __webpack_public_path__ + "static/media/Rabbit.f0d6937f.mp4";